import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import CourseReducer from './reducer/CourseReducer';
import NotifReducer from './reducer/NotifReducer';
import AllRequestsReducer from './reducer/AllReducer';
import OrgsInstructorReducer from './reducer/OrgsInstructorReducer';
import UserReducer from './reducer/UserReducer';
import SettingReducer from './reducer/SettingReducer';
import PermissionReducer from './reducer/PermissionReducer';
import LanguageReducer from './reducer/LanguageReducer';
import LevelTypeReducer from './reducer/LevelTypeReducer';
import CourseRunDemandsReducer from './reducer/CourseRunDemandsReducer';
import MyCourseRunDemandsReducer from './reducer/MyCourseRunDemandsReducer';
import OrganizationReducer from './reducer/OrganizationReducer';
//========> new structure of redux
import { organization } from './reducer/organization';
import { instructor } from './reducer/instructor';
import { course } from './reducer/course';
import { error } from './reducer/error';
import { organizationMembership } from './reducer/organizationMembership';

import { metronic } from '../../_metronic';

export const rootReducer = combineReducers({
  i18n: metronic.i18n.reducer,
  builder: metronic.builder.reducer,
  form: formReducer,
  course: CourseReducer,
  notif: NotifReducer,
  all: AllRequestsReducer,
  orgsInstructor: OrgsInstructorReducer,
  user: UserReducer,
  setting: SettingReducer,
  permission: PermissionReducer,
  language: LanguageReducer,
  levelType: LevelTypeReducer,
  courseRunDemands: CourseRunDemandsReducer,
  myCourseRunDemands: MyCourseRunDemandsReducer,
  //========> new structure of redux
  organization,
  error,
  courseNew: course,
  instructor,
  organizationMembership,
  OrganizationReducer,
});
